import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useRouter } from 'next/router';

export const useAdditionalBenefitsCheckEnabled = (): boolean => {
  const router = useRouter();
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.ADDITIONAL_BENEFITS_CHECK,
  );

  // Query param override for testing
  const queryParam = router.query['addl-benefits-check'];
  if (queryParam === 'true') {
    return true;
  }
  if (queryParam === 'false') {
    return false;
  }

  return growthBookEnabled;
};
